import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Form, Switch } from "antd";
import { useI18n } from "../../../../../contexts/i18n.js";
import { useUpsell } from "../../../../../contexts/upsell.js";
import { FormContentBlockerLayout } from "../../../layout.js";
const FormContentBlockerFieldIsVisualDarkMode = ()=>{
    const { __ } = useI18n();
    const { isPro } = useUpsell();
    return isPro && /*#__PURE__*/ _jsx(Form.Item, {
        noStyle: true,
        shouldUpdate: (prevValues, nextValues)=>prevValues.isVisual !== nextValues.isVisual || prevValues.visualType !== nextValues.visualType,
        children: ({ getFieldValue })=>{
            const isVisual = getFieldValue("isVisual");
            const visualType = getFieldValue("visualType");
            return !!isVisual && visualType !== "default" && /*#__PURE__*/ _jsx(Form.Item, {
                wrapperCol: {
                    offset: FormContentBlockerLayout.labelCol.span
                },
                children: /*#__PURE__*/ _jsxs("span", {
                    children: [
                        /*#__PURE__*/ _jsx(Form.Item, {
                            name: "isVisualDarkMode",
                            valuePropName: "checked",
                            noStyle: true,
                            children: /*#__PURE__*/ _jsx(Switch, {})
                        }),
                        "\xa0\xa0",
                        __("Enable dark mode"),
                        /*#__PURE__*/ _jsx("p", {
                            className: "description",
                            children: __("As soon as no image is found for the content blocker, a default image is automatically used. You can also specify whether the image should be displayed light or dark.")
                        })
                    ]
                })
            });
        }
    });
};
export { FormContentBlockerFieldIsVisualDarkMode };
